const init = (app) => {
  app.store.getCompany  = (success, failure) => {
    let successCallback = (response) => {
      if (response.body.data) {
        app.store.company = response.body.data
        success(response.body.data)
      }
    }

    let errorCallback = (response) => {
      app.store.company = null
      failure('request failed')
    }

    if (app.store.company) {
      success(app.store.company)
    } else {
      let company_id = app.$cookies.get('company_id')
      let token = app.$cookies.get('api_token')
      if (company_id && token) {
        app.$http.get(app.urls.companies + company_id, { headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
      } else {
        if (!company_id) {
          success(null)
        } else {
          failure('not signed in')
        }
      }
    }
  }
}

export default {
  init
}


// WEBPACK FOOTER //
// ./src/stores/Companies.js